import { call, put, select } from 'redux-saga/effects';
import { getRisk as getRiskAda } from '@gcloud-npm/adabyron.abs-layer.client.get-risk';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getRisk(params) {
  const { normalizeHttpErrors, reduxUpdate } = params;

  try {
    const context = yield select(contextStore);
    const response = yield call(getRiskAda, { context });
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_RISK, error);

    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
